export default __webpack_public_path__ + "static/media/gold_item.64e17777.png";